<script setup lang="ts">
  import { computed, useId } from 'vue';
  import {
    actionsClass,
    contentClass,
    fixedClass,
    footerClass,
    startClass,
    stickyClass,
  } from './PageFooter.css';
  import type { PageFooterProps } from './PageFooter.types';

  const props = withDefaults(defineProps<PageFooterProps>(), {
    fixed: false,
  });

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-page-footer-${uid}`,
  );

  const rootClasses = computed(() => [
    footerClass,
    props.fixed ? fixedClass : stickyClass,
  ]);
</script>

<template>
  <div :class="rootClasses" :data-testid="resolvedTestId">
    <div :class="contentClass">
      <div
        v-if="$slots.default"
        :class="startClass"
        :data-testid="`${resolvedTestId}-start`"
      >
        <slot />
      </div>
      <div
        v-if="$slots.actions"
        :class="actionsClass"
        :data-testid="`${resolvedTestId}-actions`"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
